import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 3, height: 12, viewBox: "0 0 3 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 0.5L0.5 11.5", stroke: "currentColor", strokeLinecap: "round" }));
export default SvgSlash;
